var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-col mb-4 radial_size"},[_c('apexchart',{attrs:{"type":"radialBar","height":"250","options":_vm.chartParams.chartOptions,"series":_vm.chartParams.series}}),_c('h4',{staticClass:"txt_center",class:{
      txt_high: _vm.score >= 90,
      txt_medium: _vm.score >= 50 && _vm.score <= 89,
      txt_low: _vm.score <= 49
    }},[_vm._v("\n    "+_vm._s(parseFloat(_vm.loadingTime).toFixed(1))+" s\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }